import type {
  FeatureFlagsSet,
  TranslatedString,
  TranslationMessage,
} from "models/featureFlag/FeatureFlagsSet";

// Default values for all feature flags
export const featureFlagDefaultValues: FeatureFlagsSet = {
  showPlatformIsDownMessageModal: false,
  customCurrentHost: "null",
  platformDownMessage: JSON.stringify<TranslationMessage>({
    en: {
      title: "We're great with languages...",
      body: " ...but less so with malfunctions. We'll get our website back online as soon as possible. Come back later?",
    },
    nl: {
      title: "We zijn even uit de lucht",
      body: "Niet voor lang, hoor. We halen onze website zo snel mogelijk weer online. Kom je zo terug?",
    },
  }),
  showPlatformUnderConstructionModal: false,
  showAdaptivePracticeFlow: true,
  showComingSoonModules: true,
  showSupportUnavailabilityNotice: false,
  alphaTesterIds: "",
  supportUnavailabilityNoticeMessage: JSON.stringify<TranslatedString>({
    nl: "Let op: 29 juni zijn wij gesloten. Wij zijn deze dag niet bereikbaar voor toetsondersteuning.",
    en: "Please note: We are closed on June 29th. We are not available for test support on this day.",
  }),
  tallyForm: {
    en: "wzMJKq",
    nl: "wzMJKq",
  },
  isBusinessThemeActive: false,
  minimumTheoryContentLength: 0,
  showSupportWidget: false,
  showSchoolYearFilter: false,
  showAdaptivePracticeSessionResultsPage: false,
  adaptivePracticeCongratsMessageDuration: 5,
  showTeacherInstructionsFilters: false,
  canSetInitialProgressFromIntakeTestResults: false,
  enableActiveSessionTokenValidation: false,
  activeSessionTokenValidationIntervalSeconds: 10,
  showPlayerPocPage: false,
  showSubjectsGroupedByModuleSection: false,
};
